import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { UpdateItemStockRequestSchema } from '.././client-sdk/api';

export const useStockApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllStocks = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getAllItemStocks(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          query.storeId,
          searchParam
,
        );
        return response;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getEditStockQuantity = useCallback(
    async (itemId: any, stockData: UpdateItemStockRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.updateItemStock(itemId, stockData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    getAllStocks,
    loading,
    error,
    getEditStockQuantity,
  };
};
